document.querySelectorAll('[data-gallery-thumb]').forEach(link => {
  link.addEventListener('click', event => {
    const main = document.querySelector('.main-product-image');
    if (!main) return;
    event.preventDefault();
    main.src = link.href;
    main.removeAttribute('srcset');
    const thumb = link.querySelector('img');
    if (thumb) main.alt = thumb.alt;
  });
});

document.querySelectorAll('[data-option-fields]').forEach(fields => {
  const form = fields.closest('form');
  const master = form.querySelector('[data-variant-select]');
  const source = document.querySelector('[data-option-variants]');
  if (!master || !source) return;
  const variants = JSON.parse(source.textContent);
  const selectors = [...fields.querySelectorAll('[data-option-index]')];
  const summary = form.querySelector('[data-selection-summary]');
  const button = form.querySelector('[data-add-button]');
  fields.hidden = false;
  master.hidden = true;
  form.querySelector('[data-variant-label]').hidden = true;
  const sync = () => {
    const values = selectors.map(select => select.value);
    const variant = variants.find(item => item.options.every((value, index) => value === values[index]));
    if (variant) {
      master.disabled = false;
      master.value = String(variant.id);
      master.dispatchEvent(new Event('change', {bubbles: true}));
      summary.textContent = variant.title;
    } else {
      master.disabled = true;
      button.disabled = true;
      button.textContent = summary.dataset.unavailable;
      summary.textContent = summary.dataset.unavailable;
      const status = document.querySelector('[data-stock-status]');
      if (status) status.textContent = summary.dataset.unavailable;
      const price = document.querySelector('[data-product-price]');
      if (price) price.textContent = '—';
      const url = new URL(location.href);
      url.searchParams.delete('variant');
      history.replaceState({}, '', url);
    }
  };
  selectors.forEach(select => select.addEventListener('change', sync));
  form.addEventListener('submit', event => { if (master.disabled) event.preventDefault(); });
});

document.querySelectorAll('[data-close-filters]').forEach(button => {
  button.addEventListener('click', () => {
    const panel = button.closest('details');
    panel.open = false;
    panel.querySelector('summary').focus();
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.mobile-menu[open]');
  const filters = document.querySelector('[data-responsive-filters][open]');
  const panel = menu || (matchMedia('(max-width: 760px)').matches && filters);
  if (panel) { panel.open = false; panel.querySelector('summary').focus(); }
});
document.addEventListener('click', event => {
  document.querySelectorAll('.desktop-nav .category-nav[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.querySelectorAll('[data-variant-select]').forEach(select => {
  select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    const button = select.form.querySelector('[data-add-button]');
    const price = document.querySelector('[data-product-price]');
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.addLabel : button.dataset.unavailableLabel;
    if (price) {
      price.replaceChildren(document.createTextNode(option.dataset.price));
      if (option.dataset.compare) { const compare = document.createElement('s'); compare.textContent = option.dataset.compare; price.append(' ', compare); }
    }
    const stock = document.querySelector('[data-stock-status]');
    if (stock) stock.textContent = available ? stock.dataset.stockLabel : stock.dataset.soldLabel;
    const sku = document.querySelector('[data-product-sku]');
    if (sku) sku.textContent = option.dataset.sku;
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  });
});

const filterPanel=document.querySelector('[data-responsive-filters]');
if(filterPanel){const wide=matchMedia('(min-width: 761px)');const setPanel=()=>{filterPanel.open=wide.matches};setPanel();wide.addEventListener('change',setPanel)}
document.querySelectorAll('[data-facet-link] a').forEach(link=>{const target=new URL(link.href,location.origin);const current=new URL(location.href);for(const [key,value] of current.searchParams){if(key!=='page')target.searchParams.append(key,value)}link.href=target.href});
const sorting=document.querySelector('.catalog-sidebar [name="sort_by"]');if(sorting)sorting.addEventListener('change',()=>sorting.form.requestSubmit());

document.querySelectorAll('[data-rayka-specs]').forEach(source => {
  const region = source.closest('.catalog');
  if (!region) return;
  const url = new URL(location.href);
  const legacy = {
    'filter.v.availability': 'availability',
    'filter.v.price.gte': 'price_min',
    'filter.v.price.lte': 'price_max',
    'filter.p.vendor': 'vendor'
  };
  let migrated = false;
  [...url.searchParams].forEach(([name, value]) => {
    const key = name.startsWith('filter.p.m.custom.') ? name.split('.').pop() : legacy[name];
    if (!key) return;
    if (!url.searchParams.getAll('rayka.' + key).includes(value)) url.searchParams.append('rayka.' + key, value);
    url.searchParams.delete(name);
    migrated = true;
  });
  // Reload once without Shopify's server-side constraints so clearing a facet
  // can restore every product, including after Apply, sorting or a shared URL.
  if (migrated) { location.replace(url.href); return; }

  const data = JSON.parse(source.textContent);
  const french = document.documentElement.lang.startsWith('fr');
  const normalize = value => String(value).trim().toLowerCase().replace(/\s+/g, '');
  const list = value => Array.isArray(value) ? value : value ? [value] : [];
  const capacities = value => {
    const found = [...String(value).matchAll(/(\d+(?:\.\d+)?)\s*(tb|gb)\b/gi)];
    if (found.length) return found.map(match => Number(match[1]) * (match[2].toLowerCase() === 'tb' ? 1024 : 1));
    return /^\d+$/.test(String(value).trim()) ? [Number(value)] : [];
  };
  const conditionOf = (product, variant) => {
    const explicit = variant.options.find(option => /condition|grade|cosmetic/i.test(option.name));
    const variantCondition = (variant.title || '').replace(/Excallant/gi, 'Excellent').match(/\b(Excellent|Good|Fair|Brand New|New|Perfect)\b/i);
    const text = explicit ? explicit.value.replace(/Excallant/gi, 'Excellent') : variantCondition ? variantCondition[1] : product.title || '';
    const match = text.match(/\b(Excellent|Good|Fair|Brand New|New|Perfect)\b/i);
    return match ? match[1].toLowerCase().replace(/\b\w/g, letter => letter.toUpperCase()) : '';
  };
  const variantCapacities = (product, variant, key) => {
    const pattern = key === 'ram_capacity' ? /ram|memory/i : /ssd|storage|hard.?drive|hdd/i;
    const options = variant.options.filter(option => pattern.test(option.name) && capacities(option.value).length);
    if (options.length) return options.flatMap(option => capacities(option.value));
    const composite = variant.options.filter(option => /configuration/i.test(option.name)).flatMap(option => capacities(option.value));
    const inferred = composite.filter(amount => key === 'ram_capacity' ? amount <= 64 : amount >= 120);
    if (inferred.length) return inferred;
    const fixed = list(product[key]);
    return fixed.length === 1 ? capacities(fixed[0]) : [];
  };
  const capacityLabel = value => value >= 1024 && value % 1024 === 0 ? (value / 1024) + ' TB' : value + ' GB';
  data.products.forEach(product => {
    product.vendor = list(product.vendor);
    product.cpu = list(product.cpu);
    if (!product.cpu.length) {
      const intel = (product.title || '').match(/\bi([3579])\b/i);
      const amd = (product.title || '').match(/Ryzen\s*([3579])/i);
      const apple = /Apple|MacBook/i.test(product.title || '') ? (product.title || '').match(/\b(M[1-9](?:\s+(?:Pro|Max|Ultra))?)\b/i) : null;
      product.cpu = intel ? ['Intel i' + intel[1]] : amd ? ['AMD Ryzen ' + amd[1]] : apple ? ['Apple ' + apple[1]] : [];
    }
    product.processor_brand = [...new Set(product.cpu.map(cpu => /AMD|Ryzen/i.test(cpu) ? 'AMD' : /Intel|\bi[3579]\b/i.test(cpu) ? 'Intel' : /Apple|\bM[1-9]/i.test(cpu) ? 'Apple' : '').filter(Boolean))];
  });
  const valuesFor = (product, variant, key) => {
    if (key === 'availability') return [variant.available ? '1' : '0'];
    if (key === 'condition') return [conditionOf(product, variant)].filter(Boolean);
    if (key === 'ram_capacity' || key === 'storage_capacity') return variantCapacities(product, variant, key).map(capacityLabel);
    return list(product[key]);
  };
  const equal = (key, a, b) => key === 'ram_capacity' || key === 'storage_capacity'
    ? capacities(a).some(amount => capacities(b).includes(amount)) : normalize(a) === normalize(b);

  const form = region.querySelector('.filter-form');
  const filterList = region.querySelector('.filter-list');
  if (!form || !filterList) return;
  // Build every specification facet from the same complete product/variant
  // data that is used to match cards. This avoids stale or missing options.
  filterList.querySelectorAll('fieldset').forEach(fieldset => {
    if (fieldset.dataset.specGroup || fieldset.querySelector('[data-spec-key],input[name^="filter.p.m.custom."],input[name="filter.v.availability"],input[name="filter.p.vendor"]')) fieldset.remove();
  });
  const minInput = region.querySelector('[name="filter.v.price.gte"]');
  const maxInput = region.querySelector('[name="filter.v.price.lte"]');
  if (minInput) minInput.name = 'rayka.price_min';
  if (maxInput) maxInput.name = 'rayka.price_max';
  const fields = [
    ['vendor', french ? 'Marque' : 'Brand'],
    ['processor_brand', french ? 'Fabricant du processeur' : 'Processor brand'],
    ['cpu', french ? 'Famille de processeur' : 'Processor family'],
    ['condition', french ? 'État' : 'Condition'],
    ['availability', french ? 'Disponibilité' : 'Availability'],
    ['ram_capacity', french ? 'Mémoire (RAM)' : 'Memory (RAM)'],
    ['storage_capacity', french ? 'Capacité de stockage' : 'Storage capacity'],
    ['screen_size', french ? "Taille de l’écran" : 'Screen size'],
    ['intel_generation', french ? 'Génération Intel' : 'Intel generation'],
    ['amd_series', french ? 'Série AMD' : 'AMD series']
  ];
  const anchor = filterList.querySelector('fieldset,button[type="submit"]');
  fields.forEach(([key, caption]) => {
    const values = [...new Set(data.products.flatMap(product => product.variants.flatMap(variant => valuesFor(product, variant, key))).filter(Boolean))];
    url.searchParams.getAll('rayka.' + key).forEach(value => { if (!values.some(item => equal(key, item, value))) values.push(value); });
    if (!values.length) return;
    values.sort((a, b) => key === 'ram_capacity' || key === 'storage_capacity' ? capacities(a)[0] - capacities(b)[0] : String(a).localeCompare(String(b), undefined, {numeric:true}));
    const fieldset = document.createElement('fieldset'); fieldset.dataset.specGroup = key;
    const legend = document.createElement('legend'); legend.textContent = caption; fieldset.append(legend);
    values.forEach(value => {
      const label = document.createElement('label'); label.className = 'check-row';
      const input = document.createElement('input'); input.type = 'checkbox'; input.name = 'rayka.' + key; input.value = value; input.dataset.specKey = key;
      const text = document.createElement('span');
      text.textContent = key === 'availability' ? value === '1' ? (french ? 'En stock' : 'In stock') : (french ? 'Rupture de stock' : 'Out of stock') : value;
      const count = document.createElement('span'); count.dataset.facetCount = ''; text.append(count);
      label.append(input, text); fieldset.append(label);
    });
    filterList.insertBefore(fieldset, anchor);
  });
  const inputs = [...region.querySelectorAll('[data-spec-key]')];
  const cards = new Map([...region.querySelectorAll('[data-spec-product]')].map(card => [card.dataset.specProduct, card]));
  const cardOrder = [...cards.values()];
  const active = region.querySelector('[data-spec-active]');
  const sortSelect = region.querySelector('[name="sort_by"]');
  const initialSort = sortSelect ? sortSelect.value : '';
  const hydrate = () => {
    const params = new URL(location.href).searchParams;
    inputs.forEach(input => { input.checked = params.getAll(input.name).some(value => equal(input.dataset.specKey, input.value, value)); });
    [[minInput, 'price_min'], [maxInput, 'price_max']].forEach(([input, key]) => {
      if (!input) return;
      const value = params.get('rayka.' + key);
      input.value = value !== null && value.trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : '';
    });
  };
  const apply = () => {
    const selections = new Map();
    inputs.filter(input => input.checked).forEach(input => {
      if (!selections.has(input.dataset.specKey)) selections.set(input.dataset.specKey, []);
      selections.get(input.dataset.specKey).push(input.value);
    });
    const matches = (product, variant, ignoredKey) => {
      if (product.budget && variant.price > product.budget) return false;
      if (minInput && minInput.value !== '' && variant.price < Number(minInput.value) * 100) return false;
      if (maxInput && maxInput.value !== '' && variant.price > Number(maxInput.value) * 100) return false;
      return [...selections].every(([key, values]) => key === ignoredKey || values.some(value => valuesFor(product, variant, key).some(actual => equal(key, value, actual))));
    };
    let count = 0;
    const filtered = selections.size > 0 || Boolean(minInput && minInput.value) || Boolean(maxInput && maxInput.value);
    data.products.forEach(product => {
      const card = cards.get(String(product.id));
      if (!card) return;
      const matching = product.variants.filter(variant => matches(product, variant));
      card.hidden = matching.length === 0;
      if (card.hidden) return;
      count++;
      const stocked = matching.filter(variant => variant.available);
      const choices = (stocked.length ? stocked : matching).slice().sort((a, b) => a.price - b.price);
      const chosen = choices[0];
      card.dataset.specPrice = chosen.price;
      const stock = card.querySelector('[data-card-stock]');
      if (stock) { stock.textContent = chosen.available ? stock.dataset.stockLabel : stock.dataset.soldLabel; stock.classList.toggle('unavailable', !chosen.available); }
      const href = filtered || product.budget ? product.url + '?variant=' + chosen.id : product.url;
      card.querySelectorAll('a:not([data-config-link])').forEach(link => { link.href = href; });
      card.querySelectorAll('[data-config-id]').forEach(row => { row.hidden = !matching.some(variant => String(variant.id) === row.dataset.configId); });
      const configs = card.querySelector('.rk-card-configs');
      if (configs) configs.hidden = ![...configs.querySelectorAll('[data-config-id]')].some(row => !row.hidden);
      const price = card.querySelector('[data-card-price]');
      if (price) {
        if (!price.dataset.originalHtml) price.dataset.originalHtml = price.innerHTML;
        if (filtered) price.textContent = (choices.some(variant => variant.price !== chosen.price) ? (french ? 'À partir de ' : 'From ') : '') + chosen.formattedPrice;
        else price.innerHTML = price.dataset.originalHtml;
      }
      const compare = card.querySelector('[data-card-compare]');
      if (compare) compare.hidden = filtered;
    });
    if (sortSelect && /price-(ascending|descending)/.test(sortSelect.value)) {
      const direction = sortSelect.value === 'price-ascending' ? 1 : -1;
      [...cardOrder].filter(card => !card.hidden).sort((a, b) => direction * (Number(a.dataset.specPrice) - Number(b.dataset.specPrice))).forEach(card => card.parentElement.append(card));
    }
    region.querySelectorAll('[data-spec-count]').forEach(node => { node.textContent = count === 1 ? data.countSingular : data.countLabel.replace('__COUNT__', count); });
    const empty = region.querySelector('[data-spec-empty]');
    if (empty) empty.hidden = count > 0;
    // Counts reflect the other active facets and actual matching variants.
    inputs.forEach(input => {
      const key = input.dataset.specKey;
      const amount = data.products.filter(product => product.variants.some(variant => matches(product, variant, key) && valuesFor(product, variant, key).some(value => equal(key, input.value, value)))).length;
      input.disabled = amount === 0 && !input.checked;
      const counter = input.closest('label').querySelector('[data-facet-count]');
      if (counter) counter.textContent = ' (' + amount + ')';
    });
    if (active) {
      active.replaceChildren();
      inputs.filter(input => input.checked).forEach(input => {
        const chip = document.createElement('button'); chip.type = 'button';
        const label = input.dataset.specKey === 'availability' ? input.value === '1' ? (french ? 'En stock' : 'In stock') : (french ? 'Rupture de stock' : 'Out of stock') : input.value;
        chip.textContent = input.closest('fieldset').querySelector('legend').textContent + ': ' + label + ' ×';
        chip.addEventListener('click', () => { input.checked = false; apply(); }); active.append(chip);
      });
    }
    const nextUrl = new URL(location.href);
    fields.forEach(([key]) => nextUrl.searchParams.delete('rayka.' + key));
    inputs.filter(input => input.checked).forEach(input => nextUrl.searchParams.append(input.name, input.value));
    [minInput, maxInput].filter(Boolean).forEach(input => { nextUrl.searchParams.delete(input.name); if (input.value !== '') nextUrl.searchParams.set(input.name, input.value); });
    history.replaceState({}, '', nextUrl);
  };
  inputs.forEach(input => input.addEventListener('change', apply));
  [minInput, maxInput].filter(Boolean).forEach(input => { input.addEventListener('input', apply); input.addEventListener('change', apply); });
  form.addEventListener('submit', event => {
    event.preventDefault(); apply();
    if (sortSelect && sortSelect.value !== initialSort) {
      const target = new URL(location.href); target.searchParams.set('sort_by', sortSelect.value); target.searchParams.delete('page'); location.assign(target.href);
    }
  });
  window.addEventListener('popstate', () => { hydrate(); apply(); });
  hydrate(); apply();
});

// Update quantities and notes through Shopify's cart API; retain native checkout.
const cartForm = document.querySelector('.cart-form');
if (cartForm) cartForm.addEventListener('submit', async event => {
  if (event.submitter && event.submitter.name === 'checkout') return;
  event.preventDefault();
  const update = cartForm.querySelector('[name="update"]');
  const error = cartForm.querySelector('[data-cart-error]');
  update.disabled = true;
  error.hidden = true;
  try {
    const updates = {};
    cartForm.querySelectorAll('[data-cart-key]').forEach(input => { updates[input.dataset.cartKey] = Number(input.value); });
    const response = await fetch(cartForm.dataset.updateUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({updates, note:cartForm.querySelector('[name="note"]').value})});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || error.dataset.message);
    location.reload();
  } catch (failure) {
    error.textContent = failure.message || error.dataset.message;
    error.hidden = false;
    update.disabled = false;
  }
});
